import { render, staticRenderFns } from "./AddEdtRecShareDlg.vue?vue&type=template&id=4d0f5180"
import script from "./AddEdtRecShareDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtRecShareDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports